<sequence-list [sequences]="sequences$ | async"></sequence-list>
<p class="mt-2 mb-6 text-muted">
  <span i18n="@@project.settings.sequence.info1">The sequences listed here can be used in Table automations and Attribute functions.</span>
  <span i18n="@@project.settings.sequence.info2">Use the <em>sequence</em> block from the <em>Utils</em> palette in the function/automation editor.</span>
</p>
